// python
// from datetime import datetime
// a = "2023-08-17"
// datetime.strptime(a, "%Y-%m-%d").timestamp()

// python
// from datetime import datetime
// a = "2023-08-17"
// datetime.strptime(a, "%Y-%m-%d").timestamp()

export const press = [
  {
    id: "myhudson-mondo-stadia",
    title: "Voice ordering with MyHudson covered by MondoStadia",
    href: "https://issuu.com/mondiale/docs/mdst14_digitallr/88",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "Oct 2020",
    datetime: 1601506800,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/myhudson-mondo-stadia.jpg`,
    type: "article",
  },
  {
    id: "tdl-audico",
    title: "TDL introduces audico",
    href: "https://www.thedigitalline.co.uk/2022/04/10/the-digital-line-tdl-introduces-audico/",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "Apr 2022",
    datetime: 1649545200,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/tdl-audico.jpg`,
    type: "article",
  },
  {
    id: "tdl-audico-solution",
    title: "audico solution",
    href: "https://www.thedigitalline.co.uk/2023/03/20/audico-solution/",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "Mar 2023",
    datetime: 1679270400,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/tdl-audico-solution.jpg`,
    type: "article",
  },
  {
    id: "audico-ascot",
    title: "audico for Ascot Racecourse | Alexa Innovators Deep Dive",
    href: "https://www.youtube.com/embed/u7rItOEaqvo",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "Jan 2023",
    datetime: 1672531200,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/audico-ascot.jpg`,
    type: "video",
  },
  {
    id: "alexa-innovators",
    title: "Ascot Racecourse | Alexa Innovators",
    href: "https://www.youtube.com/embed/eNRvAWBnfTE",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "Jan 2023",
    datetime: 1672531200,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/alexa-innovators.jpg`,
    type: "video",
  },
  {
    id: "elavon-tdl-audico",
    title:
      "Elavon signs exclusive deal with TDL to launch new range of digital services in hospitality industry",
    href: "https://www.thedigitalline.co.uk/2023/05/17/elavon-signs-exclusive-deal-with-the-digital-line-tdl-to-launch-new-range-of-digital-services-in-hospitality-industry/",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "May 2023",
    datetime: 1682895600,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/elavon-tdl-audico.jpg`,
    type: "article",
  },
  {
    id: "elavon-launch",
    title:
      "Elavon signs exclusive deal with TDL to launch voice enabled payments with audico",
    href: "https://www.elavon.co.uk/insights/news/elavon-signs-exclusive-deal-with-the-digital-line.html",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "May 2023",
    datetime: 1682895600,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/elavon-launch.jpg`,
    type: "article",
  },
  {
    id: "pay-by-voice-elavon",
    title: "Pay by voice with Elavon & audico",
    href: "https://www.elavon.co.uk/insights/news/pay-by-voice.html",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "May 2023",
    datetime: 1682895600,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/pay-by-voice-elavon.jpg`,
    type: "article",
  },
  {
    id: "hotel-mgmt-elavon-audico",
    title: "Hotel Management Network - Elavon, TDL & audico",
    href: "https://www.hotelmanagement-network.com/news/elavon-tdl-voice-activated-solution/",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "May 2023",
    datetime: 1682895600,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/hotel-mgmt-elavon-audico.jpg`,
    type: "article",
  },
  {
    id: "epi-elavon-audico",
    title: "Electronic Payments International - Elavon, TDL & audico",
    href: "https://www.electronicpaymentsinternational.com/news/elavon-tdl-partner-launch-new-digital-services/",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "May 2023",
    datetime: 1682895600,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/epi-elavon-audico.jpg`,
    type: "article",
  },
  {
    id: "bw-elavon-audico",
    title: "Business Wire - Elavon, TDL & audico",
    href: "https://www.businesswire.com/news/home/20230517005113/en/Elavon-signs-exclusive-deal-with-Amazon-approved-partner-The-Digital-Line-TDL-to-launch-new-range-of-digital-services-in-hospitality-industry",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "May 2023",
    datetime: 1682895600,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/bw-elavon-audico.jpg`,
    type: "article",
  },
  {
    id: "pymnts-elavon-audico",
    title: "PYMNTS - Elavon, TDL & audico",
    href: "https://www.pymnts.com/voice-activation/2023/elavon-signs-deal-to-power-payments-on-voice-activated-hospitality-solution/",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "May 2023",
    datetime: 1682895600,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/pymnts-elavon-audico.jpg`,
    type: "article",
  },
  {
    id: "yahoo-elavon-audico",
    title: "Yahoo Finance - Elavon, TDL & audico",
    href: "https://uk.finance.yahoo.com/news/elavon-signs-exclusive-deal-amazon-090000152.html",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "May 2023",
    datetime: 1682895600,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/yahoo-elavon-audico.jpg`,
    type: "article",
  },
  {
    id: "alexa-case-studies",
    title: "Featured on Official Amazon Alexa Case Studies site",
    href: "https://developer.amazon.com/en-GB/alexa/alexa-case-studies",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "Feb 2023",
    datetime: 1675209600,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/alexa-case-studies.jpg`,
    type: "article",
  },
  {
    id: "mondo-stadia-pos",
    title: "MondoStadia features audico POS",
    href: "https://issuu.com/mondiale/docs/mdst31_digitallr/65",
    description:
      "Illo sint voluptas. Error voluptates culpa eligendi. Hic vel totam vitae illo. Non aliquid explicabo necessitatibus unde. Sed exercitationem placeat consectetur nulla deserunt vel. Iusto corrupti dicta.",
    date: "Aug 2023",
    datetime: 1692140400,
    author: {
      name: "Michael Foster",
      imageUrl:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    },
    bgImage: `img/graphics/press/mondo-stadia-pos.png`,
    type: "article",
  },
];

export function translateTemplateContent(field: string, templateType: string) {
  if (templateType === "WL") {
    if (field === "name") {
      return {
        EN: "Welcome",
        FR: "Bienvenue",
        IT: "Benvenuto",
        DE: "Willkommen",
      };
    }
    if (field === "description") {
      return {
        EN: "Send a welcome message to users",
        FR: "Envoyez un message de bienvenue aux utilisateurs",
        IT: "Invia un messaggio di benvenuto agli utenti",
        DE: "Senden Sie eine Willkommensnachricht an Benutzer",
      };
    }
    if (field === "header_text") {
      return {
        EN: "Welcome",
        FR: "Bienvenue",
        IT: "Benvenuto",
        DE: "Willkommen",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Hello, I'm Alexa",
        FR: "Bonjour, je suis Alexa",
        IT: "Ciao, sono Alexa",
        DE: "Hallo, ich bin Alexa",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, what can you do?"',
        FR: 'Essayez, "Alexa, que pouvez-vous faire?"',
        IT: 'Prova, "Alexa, cosa sai fare?"',
        DE: 'Versuchen Sie es mit "Alexa, was kannst du tun?"',
      };
    }
  }
  if (templateType === "WK") {
    if (field === "name") {
      return {
        EN: "Wake up call",
        FR: "Réveil",
        IT: "Sveglia",
        DE: "Weckruf",
      };
    }
    if (field === "description") {
      return {
        EN: "Prompt users to set a wake up call",
        FR: "Invitez les utilisateurs à régler un réveil",
        IT: "Invita gli utenti a impostare una sveglia",
        DE: "Fordern Sie Benutzer auf, einen Weckruf einzustellen",
      };
    }
    if (field === "header_text") {
      return {
        EN: "Alarms",
        FR: "Alarmes",
        IT: "Sveglie",
        DE: "Alarme",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Need to set a wake up call?",
        FR: "Besoin de régler un réveil?",
        IT: "Hai bisogno di impostare una sveglia?",
        DE: "Müssen Sie einen Weckruf einstellen?",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, set an alarm for 7am?"',
        FR: 'Essayez, "Alexa, réglez une alarme pour 7 heures?"',
        IT: 'Prova, "Alexa, imposta una sveglia per le 7 del mattino?"',
        DE: 'Versuchen Sie es mit "Alexa, stellen Sie einen Alarm für 7 Uhr ein?"',
      };
    }
  }
  if (templateType === "TI") {
    if (field === "name") {
      return {
        EN: "Set a timer",
        FR: "Réglez un minuteur",
        IT: "Imposta un timer",
        DE: "Stellen Sie einen Timer ein",
      };
    }
    if (field === "description") {
      return {
        EN: "Prompt users to set a timer",
        FR: "Invitez les utilisateurs à régler un minuteur",
        IT: "Invita gli utenti a impostare un timer",
        DE: "Fordern Sie Benutzer auf, einen Timer einzustellen",
      };
    }
    if (field === "header_text") {
      return {
        EN: "Timers",
        FR: "Minuteries",
        IT: "Timer",
        DE: "Timer",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Need to set a timer?",
        FR: "Besoin de régler un minuteur?",
        IT: "Hai bisogno di impostare un timer?",
        DE: "Müssen Sie einen Timer einstellen?",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, set a timer for 15 minutes"',
        FR: 'Essayez, "Alexa, réglez un minuteur pour 15 minutes"',
        IT: 'Prova, "Alexa, imposta un timer per 15 minuti"',
        DE: 'Versuchen Sie es mit "Alexa, stellen Sie einen Timer für 15 Minuten ein"',
      };
    }
  }
  if (templateType === "FB") {
    if (field === "name") {
      return {
        EN: "News briefing",
        FR: "Bulletin d'information",
        IT: "Rassegna stampa",
        DE: "Nachrichtenbriefing",
      };
    }
    if (field === "description") {
      return {
        EN: "Prompt users to hear a news briefing",
        FR: "Invitez les utilisateurs à écouter un bulletin d'information",
        IT: "Invita gli utenti a sentire un rassegna stampa",
        DE: "Fordern Sie Benutzer auf, ein Nachrichtenbriefing zu hören",
      };
    }
    if (field === "header_text") {
      return {
        EN: "News",
        FR: "Nouvelles",
        IT: "Notizie",
        DE: "Nachrichten",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Looking for your daily news briefing?",
        FR: "Vous cherchez votre bulletin d'information quotidien?",
        IT: "Stai cercando il tuo rassegna stampa quotidiano?",
        DE: "Suchen Sie Ihr tägliches Nachrichtenbriefing?",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, play the news"',
        FR: 'Essayez, "Alexa, joue les nouvelles"',
        IT: 'Prova, "Alexa, riproduci le notizie"',
        DE: 'Versuchen Sie es mit "Alexa, spiele die Nachrichten"',
      };
    }
  }
  if (templateType === "MG") {
    if (field === "name") {
      return {
        EN: "Play music by genre",
        FR: "Jouer de la musique par genre",
        IT: "Riproduci musica per genere",
        DE: "Musik nach Genre abspielen",
      };
    }
    if (field === "description") {
      return {
        EN: "Explain how to play a genre of music",
        FR: "Expliquez comment jouer un genre de musique",
        IT: "Spiega come riprodurre un genere di musica",
        DE: "Erklären Sie, wie Sie ein Musikgenre abspielen",
      };
    }
    if (field === "header_text") {
      return {
        EN: "Music",
        FR: "Musique",
        IT: "Musica",
        DE: "Musik",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Listen to your favourite music genre",
        FR: "Écoutez votre genre de musique préféré",
        IT: "Ascolta il tuo genere musicale preferito",
        DE: "Hören Sie Ihr Lieblingsmusikgenre",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, play jazz music"',
        FR: 'Essayez, "Alexa, joue de la musique jazz"',
        IT: 'Prova, "Alexa, riproduci musica jazz"',
        DE: 'Versuchen Sie es mit "Alexa, spiele Jazzmusik"',
      };
    }
  }
  if (templateType === "R1") {
    if (field === "name") {
      return {
        EN: "Play radio 1",
        FR: "Jouer la radio 1",
        IT: "Riproduci radio 1",
        DE: "Radio 1 abspielen",
      };
    }
    if (field === "description") {
      return {
        EN: "Explain how to play radio 1",
        FR: "Expliquez comment jouer la radio 1",
        IT: "Spiega come riprodurre radio 1",
        DE: "Erklären Sie, wie Sie Radio 1 abspielen",
      };
    }
    if (field === "header_text") {
      return {
        EN: "Radio",
        FR: "Radio",
        IT: "Radio",
        DE: "Radio",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Listen to the radio",
        FR: "Écoutez la radio",
        IT: "Ascolta la radio",
        DE: "Hören Sie Radio",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, play radio 1"',
        FR: 'Essayez, "Alexa, joue la radio 1"',
        IT: 'Prova, "Alexa, riproduci radio 1"',
        DE: 'Versuchen Sie es mit "Alexa, spiele Radio 1"',
      };
    }
  }
  if (templateType === "MP") {
    if (field === "name") {
      return {
        EN: "Menu prompt",
        FR: "Invite de menu",
        IT: "Invito al menu",
        DE: "Menüaufforderung",
      };
    }
    if (field === "description") {
      return {
        EN: "Explain how to ask for the menu",
        FR: "Expliquez comment demander le menu",
        IT: "Spiega come chiedere il menu",
        DE: "Erklären Sie, wie Sie nach dem Menü fragen",
      };
    }
    if (field === "header_text") {
      return {
        EN: "Menus",
        FR: "Menus",
        IT: "Menu",
        DE: "Menüs",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Want to know todays menu?",
        FR: "Vous voulez connaître le menu d'aujourd'hui?",
        IT: "Vuoi conoscere il menu di oggi?",
        DE: "Möchten Sie das heutige Menü kennen?",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, what\'s the lunch menu?"',
        FR: 'Essayez, "Alexa, quel est le menu du déjeuner?"',
        IT: 'Prova, "Alexa, qual è il menu del pranzo?"',
        DE: 'Versuchen Sie es mit "Alexa, was ist das Mittagsmenü?"',
      };
    }
  }
  if (templateType === "EP") {
    if (field === "name") {
      return {
        EN: "Events prompt",
        FR: "Invite d'événements",
        IT: "Invito agli eventi",
        DE: "Ereignisaufforderung",
      };
    }
    if (field === "description") {
      return {
        EN: "Explain how to ask for todays events",
        FR: "Expliquez comment demander les événements d'aujourd'hui",
        IT: "Spiega come chiedere gli eventi di oggi",
        DE: "Erklären Sie, wie Sie nach den heutigen Ereignissen fragen",
      };
    }
    if (field === "header_text") {
      return {
        EN: "Events",
        FR: "Événements",
        IT: "Eventi",
        DE: "Ereignisse",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Want to know todays events?",
        FR: "Vous voulez connaître les événements d'aujourd'hui?",
        IT: "Vuoi conoscere gli eventi di oggi?",
        DE: "Möchten Sie die heutigen Ereignisse kennen?",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, what are the events today?"',
        FR: 'Essayez, "Alexa, quels sont les événements aujourd\'hui?"',
        IT: 'Prova, "Alexa, quali sono gli eventi di oggi?"',
        DE: 'Versuchen Sie es mit "Alexa, was sind die Ereignisse heute?"',
      };
    }
  }
  if (templateType === "CL") {
    if (field === "name") {
      return {
        EN: "Cleaning prompt",
        FR: "Invite de nettoyage",
        IT: "Invito alla pulizia",
        DE: "Reinigungsaufforderung",
      };
    }
    if (field === "description") {
      return {
        EN: "Explain how to make a cleaning request",
        FR: "Expliquez comment faire une demande de nettoyage",
        IT: "Spiega come fare una richiesta di pulizia",
        DE: "Erklären Sie, wie Sie eine Reinigungsanfrage stellen",
      };
    }
    if (field === "header_text") {
      return {
        EN: "Cleaning",
        FR: "Nettoyage",
        IT: "Pulizia",
        DE: "Reinigung",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Want to request cleaning services?",
        FR: "Vous voulez demander des services de nettoyage?",
        IT: "Vuoi richiedere servizi di pulizia?",
        DE: "Möchten Sie Reinigungsdienste anfordern?",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, can you clean my room?"',
        FR: 'Essayez, "Alexa, pouvez-vous nettoyer ma chambre?"',
        IT: 'Prova, "Alexa, puoi pulire la mia stanza?"',
        DE: 'Versuchen Sie es mit "Alexa, können Sie mein Zimmer reinigen?"',
      };
    }
  }
  if (templateType === "FC") {
    if (field === "name") {
      return {
        EN: "Maintenance prompt",
        FR: "Invite de maintenance",
        IT: "Invito alla manutenzione",
        DE: "Wartungsaufforderung",
      };
    }
    if (field === "description") {
      return {
        EN: "Explain how to make a maintenance request",
        FR: "Expliquez comment faire une demande de maintenance",
        IT: "Spiega come fare una richiesta di manutenzione",
        DE: "Erklären Sie, wie Sie eine Wartungsanfrage stellen",
      };
    }
    if (field === "header_text") {
      return {
        EN: "Maintenance",
        FR: "Maintenance",
        IT: "Manutenzione",
        DE: "Wartung",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Does something need fixing in your room?",
        FR: "Quelque chose doit-il être réparé dans votre chambre?",
        IT: "Qualcosa deve essere sistemato nella tua stanza?",
        DE: "Muss in Ihrem Zimmer etwas repariert werden?",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: 'Try, "Alexa, can you fix my window?"',
        FR: 'Essayez, "Alexa, pouvez-vous réparer ma fenêtre?"',
        IT: 'Prova, "Alexa, puoi sistemare la mia finestra?"',
        DE: 'Versuchen Sie es mit "Alexa, können Sie mein Fenster reparieren?"',
      };
    }
  }
  if (templateType === "ER") {
    if (field === "name") {
      return {
        EN: "Event reminder",
        FR: "Rappel d'événement",
        IT: "Promemoria dell'evento",
        DE: "Ereigniserinnerung",
      };
    }
    if (field === "description") {
      return {
        EN: "Send a reminder of a specific event",
        FR: "Envoyez un rappel d'un événement spécifique",
        IT: "Invia un promemoria di un evento specifico",
        DE: "Senden Sie eine Erinnerung an ein bestimmtes Ereignis",
      };
    }
    if (field === "title") {
      return {
        EN: "Reminder",
        FR: "Rappel",
        IT: "Promemoria",
        DE: "Erinnerung",
      };
    }
    if (field === "body") {
      return {
        EN: "Your event starts in 15 minutes",
        FR: "Votre événement commence dans 15 minutes",
        IT: "Il tuo evento inizia tra 15 minuti",
        DE: "Ihr Ereignis beginnt in 15 Minuten",
      };
    }
  }
  if (templateType === "CD") {
    if (field === "name") {
      return {
        EN: "Cleaning complete",
        FR: "Nettoyage terminé",
        IT: "Pulizia completa",
        DE: "Reinigung abgeschlossen",
      };
    }
    if (field === "description") {
      return {
        EN: "Send a confirmation that cleaning is complete",
        FR: "Envoyez une confirmation que le nettoyage est terminé",
        IT: "Invia una conferma che la pulizia è completa",
        DE: "Senden Sie eine Bestätigung, dass die Reinigung abgeschlossen ist",
      };
    }
    if (field === "title") {
      return {
        EN: "Cleaning",
        FR: "Nettoyage",
        IT: "Pulizia",
        DE: "Reinigung",
      };
    }
    if (field === "body") {
      return {
        EN: "Your room has been cleaned",
        FR: "Votre chambre a été nettoyée",
        IT: "La tua stanza è stata pulita",
        DE: "Ihr Zimmer wurde gereinigt",
      };
    }
  }
  if (templateType === "MD") {
    if (field === "name") {
      return {
        EN: "Maintenance complete",
        FR: "Maintenance terminé",
        IT: "Manutenzione completa",
        DE: "Wartung abgeschlossen",
      };
    }
    if (field === "description") {
      return {
        EN: "Send a confirmation that maintenance is complete",
        FR: "Envoyez une confirmation que la maintenance est terminée",
        IT: "Invia una conferma che la manutenzione è completa",
        DE: "Senden Sie eine Bestätigung, dass die Wartung abgeschlossen ist",
      };
    }
    if (field === "title") {
      return {
        EN: "Maintenance",
        FR: "Maintenance",
        IT: "Manutenzione",
        DE: "Wartung",
      };
    }
    if (field === "body") {
      return {
        EN: "Your window has been fixed",
        FR: "Votre fenêtre a été réparée",
        IT: "La tua finestra è stata sistemata",
        DE: "Ihr Fenster wurde repariert",
      };
    }
  }
  if (templateType === "MC") {
    if (field === "name") {
      return {
        EN: "Menu carousel",
        FR: "Carrousel de menus",
        IT: "Carosello del menu",
        DE: "Menükarussell",
      };
    }
    if (field === "description") {
      return {
        EN: "A campaign of all active menus",
        FR: "Une campagne de tous les menus actifs",
        IT: "Una campagna di tutti i menu attivi",
        DE: "Eine Kampagne aller aktiven Menüs",
      };
    }
    if (field === "header") {
      return {
        EN: "Menus",
        FR: "Menus",
        IT: "Menu",
        DE: "Menüs",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Menu items will be shown here",
        FR: "Les éléments de menu seront affichés ici",
        IT: "Gli elementi del menu verranno mostrati qui",
        DE: "Menüpunkte werden hier angezeigt",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: "Menu prompt will be shown here",
        FR: "Le menu prompt sera affiché ici",
        IT: "Il prompt del menu verrà mostrato qui",
        DE: "Menüaufforderung wird hier angezeigt",
      };
    }
  }
  if (templateType === "EC") {
    if (field === "name") {
      return {
        EN: "Event carousel",
        FR: "Carrousel d'événements",
        IT: "Carosello dell'evento",
        DE: "Ereigniskarussell",
      };
    }
    if (field === "description") {
      return {
        EN: "A campaign of all active events",
        FR: "Une campagne de tous les événements actifs",
        IT: "Una campagna di tutti gli eventi attivi",
        DE: "Eine Kampagne aller aktiven Ereignisse",
      };
    }
    if (field === "header") {
      return {
        EN: "Events",
        FR: "Événements",
        IT: "Eventi",
        DE: "Ereignisse",
      };
    }
    if (field === "primary_text") {
      return {
        EN: "Events will be shown here",
        FR: "Les événements seront affichés ici",
        IT: "Gli eventi verranno mostrati qui",
        DE: "Ereignisse werden hier angezeigt",
      };
    }
    if (field === "secondary_text") {
      return {
        EN: "Events prompt will be shown here",
        FR: "Le rappel des événements sera affiché ici",
        IT: "Il prompt degli eventi verrà mostrato qui",
        DE: "Ereignisaufforderung wird hier angezeigt",
      };
    }
  }
  return null;
}

export const campaignTemplates = [
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "WL"),
    description: translateTemplateContent("description", "WL"),
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    header: translateTemplateContent("header_text", "WL"),
    primary_text: translateTemplateContent("primary_text", "WL"),
    secondary_text: translateTemplateContent("secondary_text", "WL"),
    title: translateTemplateContent("primary_text", "WL"),
    body: translateTemplateContent("secondary_text", "WL"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
    template_type: "WL",
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "WK"),
    description: translateTemplateContent("description", "WK"),
    template_type: "WK",
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "WK"),
    body: translateTemplateContent("secondary_text", "WK"),
    header: translateTemplateContent("header_text", "WK"),
    primary_text: translateTemplateContent("primary_text", "WK"),
    secondary_text: translateTemplateContent("secondary_text", "WK"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "TI"),
    description: translateTemplateContent("description", "TI"),
    template_type: "TI",
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "TI"),
    body: translateTemplateContent("secondary_text", "TI"),
    header: translateTemplateContent("header_text", "TI"),
    primary_text: translateTemplateContent("primary_text", "TI"),
    secondary_text: translateTemplateContent("secondary_text", "TI"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "FB"),
    description: translateTemplateContent("description", "FB"),
    template_type: "FB",
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "FB"),
    body: translateTemplateContent("secondary_text", "FB"),
    header: translateTemplateContent("header_text", "FB"),
    primary_text: translateTemplateContent("primary_text", "FB"),
    secondary_text: translateTemplateContent("secondary_text", "FB"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "MG"),
    description: translateTemplateContent("description", "MG"),
    template_type: "MG",
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "MG"),
    body: translateTemplateContent("secondary_text", "MG"),
    header: translateTemplateContent("header_text", "MG"),
    primary_text: translateTemplateContent("primary_text", "MG"),
    secondary_text: translateTemplateContent("secondary_text", "MG"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "R1"),
    description: translateTemplateContent("description", "R1"),
    template_type: "R1",
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "R1"),
    body: translateTemplateContent("secondary_text", "R1"),
    header: translateTemplateContent("header_text", "R1"),
    primary_text: translateTemplateContent("primary_text", "R1"),
    secondary_text: translateTemplateContent("secondary_text", "R1"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "MP"),
    description: translateTemplateContent("description", "MP"),
    template_type: "MP",
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "MP"),
    body: translateTemplateContent("secondary_text", "MP"),
    header: translateTemplateContent("header_text", "MP"),
    primary_text: translateTemplateContent("primary_text", "MP"),
    secondary_text: translateTemplateContent("secondary_text", "MP"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "EP"),
    description: translateTemplateContent("description", "EP"),
    template_type: "EP",
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "EP"),
    body: translateTemplateContent("secondary_text", "EP"),
    header: translateTemplateContent("header_text", "EP"),
    primary_text: translateTemplateContent("primary_text", "EP"),
    secondary_text: translateTemplateContent("secondary_text", "EP"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "CL"),
    description: translateTemplateContent("description", "CL"),
    template_type: "CL",
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "CL"),
    body: translateTemplateContent("secondary_text", "CL"),
    header: translateTemplateContent("header_text", "CL"),
    primary_text: translateTemplateContent("primary_text", "CL"),
    secondary_text: translateTemplateContent("secondary_text", "CL"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "FC"),
    description: translateTemplateContent("description", "FC"),
    template_type: "FC",
    display_type: "R",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "FC"),
    body: translateTemplateContent("secondary_text", "FC"),
    header: translateTemplateContent("header_text", "FC"),
    primary_text: translateTemplateContent("primary_text", "FC"),
    secondary_text: translateTemplateContent("secondary_text", "FC"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "ER"),
    description: translateTemplateContent("description", "ER"),
    template_type: "ER",
    display_type: "P",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("title", "ER"),
    body: translateTemplateContent("body", "ER"),
    header: translateTemplateContent("title", "ER"),
    primary_text: translateTemplateContent("body", "ER"),
    secondary_text: "",
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "CD"),
    description: translateTemplateContent("description", "CD"),
    template_type: "CD",
    display_type: "P",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("title", "CD"),
    body: translateTemplateContent("body", "CD"),
    header: translateTemplateContent("title", "CD"),
    primary_text: translateTemplateContent("body", "CD"),
    secondary_text: "",
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "static",
    build_type: "template",
    name: translateTemplateContent("name", "MD"),
    description: translateTemplateContent("description", "MD"),
    template_type: "MD",
    display_type: "P",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("title", "MD"),
    body: translateTemplateContent("body", "MD"),
    header: translateTemplateContent("title", "MD"),
    primary_text: translateTemplateContent("body", "MD"),
    secondary_text: "",
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "dynamic",
    build_type: "template",
    name: translateTemplateContent("name", "MC"),
    description: translateTemplateContent("description", "MC"),
    template_type: "MC",
    display_type: "R",
    dynamic_data: "true",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "MC"),
    body: translateTemplateContent("secondary_text", "MC"),
    header: translateTemplateContent("header", "MC"),
    primary_text: translateTemplateContent("primary_text", "MC"),
    secondary_text: translateTemplateContent("secondary_text", "MC"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
  {
    data_type: "dynamic",
    build_type: "template",
    name: translateTemplateContent("name", "EC"),
    description: translateTemplateContent("description", "EC"),
    template_type: "EC",
    display_type: "R",
    dynamic_data: "true",
    document: "D",
    background_image_selection: "catalog",
    background_image:
      "https://alexa-apl-graphics.s3.eu-west-2.amazonaws.com/audico/background/purple.png",
    background_image_url_array: [],
    title: translateTemplateContent("primary_text", "EC"),
    body: translateTemplateContent("secondary_text", "EC"),
    header: translateTemplateContent("header", "EC"),
    primary_text: translateTemplateContent("primary_text", "EC"),
    secondary_text: translateTemplateContent("secondary_text", "EC"),
    choose_rooms_by: "name",
    rooms: [],
    tags: [],
  },
];
